<style>
div {
    margin-top: 20px;
    margin-bottom: 20px;
}

span {
    text-decoration: underline;
    color: rgb(0,100,200);
    cursor: pointer;
    font-size: 12px;
    font-weight: normal;
    margin-left: 10px;
}

.selected {
    color: #333;
    cursor: default;
    text-decoration: none;
    font-weight: bold;
}
</style>

<script>
import Comment from './Comment.svelte'

export let comments;

let sortBy = 'top'
$: sortedComments = sortComments(comments, sortBy)

function sortComments(comments, sortBy) {
    console.log(comments)
    if(sortBy === 'top') {
        return comments
    } else {
        return comments.concat().sort((a,b) => {
            return b - a
        })
    }
}

</script>

<div>
    
    <h3>Comments<span class={(sortBy === 'top') ? 'selected' : ''} on:click={() => sortBy = 'top'}>Top</span><span class={(sortBy === 'new') ? 'selected' : ''} on:click={() => sortBy = 'new'}>New</span></h3>
    {#if sortedComments && sortedComments.length != 0}
        {#each sortedComments as commentId}
            <Comment {commentId}></Comment>
        {/each}
    {:else}
        There are no comments yet.
    {/if}
</div>